import { Component } from 'react'
import ErrorPage from './ErrorPage'
import { sendClientLog } from '../../services/api'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info)
    // П.3 task.txt: падение рендера — самая частая причина «не открывается».
    // Отправляем причину на бэкенд (logs/client.log), иначе о сбое у конкретного
    // юзера мы не узнаем: в консоль телефона заглянуть нельзя.
    try {
      sendClientLog({
        stage: 'react-error',
        message: `${String(error?.message || error)} | ${String(info?.componentStack || '').slice(0, 200)}`,
        platform: window.Telegram?.WebApp?.platform || 'unknown',
        version: window.Telegram?.WebApp?.version || '',
        hasInitData: !!window.Telegram?.WebApp?.initData,
        ua: navigator.userAgent,
      })
    } catch { /* диагностика не критична */ }
  }

  retry = () => this.setState({ hasError: false, error: null })

  render() {
    if (this.state.hasError) {
      // error пробрасываем на экран «Технические неполадки» — юзер не всегда
      // может открыть консоль, а по тексту ошибки легко понять причину сбоя.
      return <ErrorPage onRetry={this.retry} error={this.state.error} />
    }
    return this.props.children
  }
}
